import {fromJS} from 'immutable';
import navActions from '../actions/nav.actions';

export const DEFAULT_STATE = fromJS({
    isExpanded: false
});

export default function(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case navActions.TYPES.START_HOVER:
            return state.set('isExpanded', true);

        case navActions.TYPES.END_HOVER:
            return state.set('isExpanded', false);

        default:
            return state;
    }
}
